import {StorageApi} from '../utils/storageApi';
import {Utils} from '../utils/utils';
import _ from 'lodash';

export class Api {

    static fetchGetRequest(path) {
        return fetch(path);
    }

    static fetchGetRequestWithToken(path) {
        let token = StorageApi.getLoginToken();

        return fetch(path, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
    }

    static fetchPostRequest(path, data) {
        return fetch(path, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

    static fetchPostRequestWithToken(path, data) {
        let token = StorageApi.getLoginToken();

        return fetch(path, {
            method: "POST",
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

    static fetchPostRequestWithTokenWithTextBody(path, data) {
        let token = StorageApi.getLoginToken();

        return fetch(path, {
            method: "POST",
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'text/plain'
            },
            body: data
        });
    }

    static fetchPutRequestWithToken(path, data) {
        let token = StorageApi.getLoginToken();

        return fetch(path, {
            method: "PUT",
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

    static fetchDeleteRequestWithToken(path) {
        let token = StorageApi.getLoginToken();

        return fetch(path, {
            method: "DELETE",
            headers: {
                'Authorization': 'Bearer ' + token
            }
        })
    }

    static fetchDeleteRequestWithTokenAndBody(path, data) {
        let token = StorageApi.getLoginToken();

        return fetch(path, {
            method: "DELETE",
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
    }

    static getToken(data) {
        let path = '/api/login';

        return fetch(path, {
            method: "POST",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: Utils.objectToFormData(data)
        });
    }

    static getUserDataByToken(token) {
        let path = '/api/user';

        return fetch(path, {
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });
    }

    static getUserData() {
        let path = '/api/user';

        return this.fetchGetRequestWithToken(path);
    }

    static checkEmailAvailability(email) {
        let path = '/api/user/email?email=' + email;

        return fetch(path);
    }

    static checkOAuthRequest(params) {
        let path = '/api/oauth/authorize' + params;

        return fetch(path);
    }

    static sendOAuthGiveAccess(data) {
        let path = '/api/oauth/authorize?';

        path += Utils.convertParamsToLocationSearch(data);

        return this.fetchPostRequestWithToken(path);
    }

    static getInserterGroups() {
        let path = '/api/organization/accreditation-groups/inserter-list';

        return this.fetchGetRequestWithToken(path);
    }

    static getValidatorGroups() {
        let path = '/api/organization/accreditation-groups/validator-list';

        return this.fetchGetRequestWithToken(path);
    }

    static getHMGroups() {
        let path = '/api/organization/departments/hm-list';

        return this.fetchGetRequestWithToken(path);
    }

    static getBOGroups() {
        let path = '/api/organization/departments/bo-list';

        return this.fetchGetRequestWithToken(path);
    }

    static activateAccount(token, data) {
        let path = '/api/user/activation';

        return fetch(path, {
            method: "PUT",
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

    static registerApplicant(language, data) {
        let path = '/api/user?language=' + language;

        return this.fetchPostRequest(path, data);
    }

    static sendResetPasswordEmail(email) {
        let path = '/api/user/password';

        return this.fetchPostRequest(path, email);
    }

    static resetPassword(token, password) {
        let path = '/api/user/password';

        return fetch(path, {
            method: "PUT",
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(password)
        })
    }

    static changePassword(data) {
        let path = '/api/user/change-password';

        return this.fetchPutRequestWithToken(path, data)
    }

    static changeEmail(email) {
        let path = '/api/user/email';

        return this.fetchPostRequestWithToken(path, email);
    }

    static submitChangeEmail(token) {
        let path = '/api/user/email';

        return fetch(path, {
            method: "PUT",
            headers: {
                'Authorization': 'Bearer ' + token,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
    }

    static getTranslationByPath(path) {
        return fetch(path);
    }

    static getTranslations() {
        let path = '/static/translations/translations_list.json';

        return fetch(path);
    }

    static getAliases() {
        let path = '/api/user/aliases';

        return this.fetchGetRequestWithToken(path);
    }

    static addAlias(data) {
        let path = '/api/user/aliases';

        return this.fetchPostRequestWithToken(path, data);
    }

    static updateAlias(id, data) {
        let path = '/api/user/aliases/' + id;

        return this.fetchPutRequestWithToken(path, data);
    }

    static removeAlias(id) {
        let path = '/api/user/aliases/' + id;

        return this.fetchDeleteRequestWithToken(path);
    }

    static getDefaultAlias() {
        let path = '/api/user/aliases/default';

        return this.fetchGetRequestWithToken(path);
    }

    static setDefaultAlias(data) {
        let path = '/api/user/aliases/default';

        return this.fetchPutRequestWithToken(path, data);
    }

    static getCountries() {
        let path = '/api/countries';

        return this.fetchGetRequest(path);
    }

    static getOrgs(validated, page, countryCode, name) {
        let path = '/api/system/organizations?size=10';

        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        if (!_.isNil(validated)) {
            path += ('&validatedFilter=' + validated);
        }

        if (!_.isEmpty(countryCode)) {
            path += ('&countryCodeFilter=' + countryCode);
        }

        if (!_.isEmpty(name)) {
            path += '&nameFilter=' + name;
        }

        return this.fetchGetRequestWithToken(path);
    }

    static getOrgsWithoutCertificates(page) {
        let path = '/api/system/organizations?validatedFilter=true&certificateSpecifiedFilter=false&hasIVsFilter=true&size=10';

        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        return this.fetchGetRequestWithToken(path);
    }

    static registerOrganization(data) {
        let path = '/api/system/organizations';

        return this.fetchPostRequestWithToken(path, data);
    }

    static updateOrganizationValidatedState(id, isValidated) {
        let path = '/api/system/organizations/' + id + '/validated';

        return this.fetchPutRequestWithToken(path, isValidated);
    }

    static updateOrganizationGeneralData(id, data) {
        let path = '/api/system/organizations/' + id + '/general';

        return this.fetchPutRequestWithToken(path, data);
    }

    static updateOrganizationFinancialData(id, data) {
        let path = '/api/system/organizations/' + id + '/financial-data';
        
        return this.fetchPutRequestWithToken(path, data);
    }

    static getOrganizationDataById(id) {
        let path = '/api/system/organizations/' + id;

        return this.fetchGetRequestWithToken(path);
    }

    static getOrg() {
        let path = '/api/organization';

        return this.fetchGetRequestWithToken(path);
    }

    static resendActivation(email) {
        let path = '/api/user/activation';

        return this.fetchPostRequest(path, email);
    }

    static getStaffMembers(page, size) {
        let pageSize = 10;
        if (!_.isNil(size)) {
            pageSize = size;
        }
        let path = '/api/organization/staff?size=' + pageSize;
        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        return this.fetchGetRequestWithToken(path);
    }

    static registerStaff(data) {
        let path = '/api/organization/staff';

        return this.fetchPostRequestWithToken(path, data);
    }

    static removeStaffMember(staffMemberId) {
        let path = '/api/organization/staff/' + staffMemberId;

        return this.fetchDeleteRequestWithToken(path);
    }

    static getAccreditationGroups(page) {
        let path = '/api/organization/accreditation-groups?size=10';
        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        return this.fetchGetRequestWithToken(path);
    }

    static registerAccreditationGroup(data) {
        let path = '/api/organization/accreditation-groups';

        return this.fetchPostRequestWithToken(path, data);
    }

    static editAccreditationGroup(groupId, data) {
        let path = '/api/organization/accreditation-groups/' + groupId;

        return this.fetchPutRequestWithToken(path, data);
    }

    static getAccreditationGroup(id) {
        let path = '/api/organization/accreditation-groups/' + id;

        return this.fetchGetRequestWithToken(path)
    }

    static getEmployeesByAccreditationGroupAndRole(id, role) {
        let path = '/api/organization/accreditation-groups/' + id + '/staff?role=' + role;

        return this.fetchGetRequestWithToken(path)
    }

    static addEmployeeToAccreditationGroup(groupId, employeeId, role) {
        let path = '/api/organization/accreditation-groups/' + groupId + '/staff';

        return this.fetchPutRequestWithToken(path, {id: employeeId, role});
    }

    static removeEmployeeFromAccreditationGroup(groupId, employeeId, role) {
        let path = '/api/organization/accreditation-groups/' + groupId + '/staff';

        return this.fetchDeleteRequestWithTokenAndBody(path, {id: employeeId, role});
    }

    static removeAccreditationGroup(groupId) {
        let path = '/api/organization/accreditation-groups/' + groupId;

        return this.fetchDeleteRequestWithToken(path);
    }

    static getDepartments(page) {
        let path = '/api/organization/departments?size=10';
        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        return this.fetchGetRequestWithToken(path);
    }

    static editDepartment(departmentId, data) {
        let path = '/api/organization/departments/' + departmentId;

        return this.fetchPutRequestWithToken(path, data);
    }

    static registerDepartment(data) {
        let path = '/api/organization/departments';

        return this.fetchPostRequestWithToken(path, data);
    }

    static getDepartment(departmentId) {
        let path = '/api/organization/departments/' + departmentId;

        return this.fetchGetRequestWithToken(path)
    }

    static getEmployeesByDepartmentAndRole(departmentId, role) {
        let path = '/api/organization/departments/' + departmentId + '/staff?role=' + role;

        return this.fetchGetRequestWithToken(path)
    }

    static addEmployeeToDepartment(departmentId, employeeId, role) {
        let path = '/api/organization/departments/' + departmentId + '/staff';

        return this.fetchPutRequestWithToken(path, {id: employeeId, role});
    }

    static removeEmployeeFromDepartment(departmentId, employeeId, role) {
        let path = '/api/organization/departments/' + departmentId + '/staff';

        return this.fetchDeleteRequestWithTokenAndBody(path, {id: employeeId, role});
    }

    static removeDepartment(departmentId) {
        let path = '/api/organization/departments/' + departmentId;

        return this.fetchDeleteRequestWithToken(path);
    }

    static changeAnchor(data) {
        let path = '/api/organization/anchor';

        return this.fetchPostRequestWithToken(path, data);
    }

    static getTitleCodes() {
        let path = '/api/organization/accreditations/title-codes';

        return this.fetchGetRequestWithToken(path);
    }

    static getLevels() {
        let path = '/api/organization/accreditations/levels';

        return this.fetchGetRequestWithToken(path);
    }

    static insertAccreditation(data) {
        let path = '/api/organization/accreditations';

        return this.fetchPostRequestWithToken(path, data);
    }

    static getAccreditationsForValidation(groupId, countryFilter, domainFilter, page) {
        let path = '/api/organization/accreditations/pending?accredGroupId=' + groupId + '&size=10';
        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }
        if (!_.isNil(countryFilter)) {
            path += ('&countryCodeFilter=' + countryFilter);
        }
        if (!_.isNil(domainFilter)) {
            path += '&domainFilter=' + domainFilter
        }

        return this.fetchGetRequestWithToken(path);
    }

    static getStaticsticsForAccreditationsForValidation(group, countryCode, groupBy) {
        let path = '/api/organization/accreditations/pending/statistics?accredGroupId=' + group;

        if (!_.isNil(countryCode)) {
            path += '&countryCodeFilter=' + countryCode;
        }

        if (!_.isNil(groupBy)) {
            path += '&groupBy=' + groupBy;
        }

        return this.fetchGetRequestWithToken(path);
    }

    static validateAccreditation(accreditationId, data) {
        let path = '/api/organization/accreditations/' + accreditationId + '/validation';

        return this.fetchPostRequestWithToken(path, data);
    }

    static getAccreditationsForReviewByGroupId(groupId, page, isInternal, countryFilter, domainFilter) {
        let path = '/api/organization/accreditations/rejected?accredGroupId=' + groupId + '&size=10';
        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        path += '&status=REJECTED_BY_' + (isInternal ? 'VALIDATOR' : 'APPLICANT');

        if (!_.isNil(countryFilter)) {
            path += ('&countryCodeFilter=' + countryFilter);
        }
        if (!_.isNil(domainFilter)) {
            path += '&domainFilter=' + domainFilter;
        }

        return this.fetchGetRequestWithToken(path);
    }

    static getStatisticsForRejectedAccreditations(group, isInternal, countryCode, groupBy) {
        let path = '/api/organization/accreditations/rejected/statistics?accredGroupId=' + group;

        path += '&status=REJECTED_BY_' + (isInternal ? 'VALIDATOR' : 'APPLICANT');

        if (!_.isNil(countryCode)) {
            path += '&countryCodeFilter=' + countryCode;
        }

        if (!_.isNil(groupBy)) {
            path += '&groupBy=' + groupBy;
        }

        return this.fetchGetRequestWithToken(path);
    }

    static reviewAccreditation(accreditationId, data) {
        let path = '/api/organization/accreditations/' + accreditationId;

        return this.fetchPostRequestWithToken(path, data);
    }

    static removeAccreditation(accreditationId) {
        let path = '/api/organization/accreditations/' + accreditationId;

        return this.fetchDeleteRequestWithToken(path);
    }

    static getBulkJobs(groupId) {
        let path = '/api/organization/accreditations/bulk?accredGroupId=' + groupId;

        return this.fetchGetRequestWithToken(path);
    }

    static fetchUploadBulkAccreditationsAsFile(data) {
        let path = '/api/organization/accreditations/bulk/file';

        let token = StorageApi.getLoginToken();
        return fetch(path, {
            method: "POST",
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: data
        })
    }

    static fetchUploadBulkAccreditationsAsJSON(data) {
        let path = '/api/organization/accreditations/bulk/json';

        return this.fetchPostRequestWithToken(path, data);
    }

    static removeBulk(bulkId) {
        let path = '/api/organization/accreditations/bulk/' + bulkId;

        return this.fetchDeleteRequestWithToken(path);
    }

    static changeAnchorBySysAdmin(orgId, anchorData) {
        let path = '/api/system/organizations/' + orgId + '/anchor';

        return this.fetchPostRequestWithToken(path, anchorData);
    }

    static getCertifiedAccreditations() {
        let path = '/api/user/accreditations';

        return this.fetchGetRequestWithToken(path);
    }

    static updateCertifiedAccreditation(id, data) {
        let path = '/api/user/accreditations/' + id;

        return this.fetchPutRequestWithToken(path, data);
    }

    static removeCertifiedAccreditation(id) {
        let path = '/api/user/accreditations/' + id;

        return this.fetchDeleteRequestWithToken(path);
    }

    static getPendingAccreditations() {
        let path = '/api/user/accreditations/pending';

        return this.fetchGetRequestWithToken(path);
    }

    static validatePendingAccreditation(accreditationId, data) {
        let path = '/api/user/accreditations/pending/' + accreditationId + '/review';

        return this.fetchPostRequestWithToken(path, data);
    }

    static discardPendingAccreditation(accreditationId) {
        let path = '/api/user/accreditations/pending/' + accreditationId;

        return this.fetchDeleteRequestWithToken(path);
    }

    static getAllVIDs() {
        let path = '/api/user/verified-identities';

        return this.fetchGetRequestWithToken(path);
    }

    static updateVID(id, data) {
        let path = '/api/user/verified-identities/' + id;

        return this.fetchPutRequestWithToken(path, data);
    }

    static activateVID(id) {
        let path = '/api/user/verified-identities/' + id + '/activate';

        return this.fetchPostRequestWithToken(path);
    }

    static updateOrgByAnchor(data) {
        let path = '/api/organization';

        return this.fetchPutRequestWithToken(path, data);
    }

    static getCurrencies() {
        let path = '/api/system/currencies';

        return this.fetchGetRequestWithToken(path);
    }

    static changeOrganizationBalance(id, data) {
        let path = '/api/system/organizations/' + id + '/balance';

        return this.fetchPostRequestWithToken(path, data);
    }

    static getPriceByOrgTypeAndCountry(orgType, countryCode) {
        let path = '/api/system/organizations/default-financial-settings?organizationType=' + orgType + "&countryCode=" + countryCode;

        return this.fetchGetRequestWithToken(path);
    }

    static getPresets() {
        let path = '/api/system/pricing-presets';

        return this.fetchGetRequestWithToken(path);
    }

    static convertMoney(data) {
        let path = '/api/system/currencies/exchange?amount=' + data.amount + '&currencyFrom=' + data.currencyFrom + '&currencyTo=' + data.currencyTo;

        return this.fetchGetRequestWithToken(path);
    }

    static getOrgBalance() {
        let path = '/api/organization/balance';

        return this.fetchGetRequestWithToken(path);
    }

    static registerOrgByAnchor(language, data) {
        let path = '/api/organization?language=' + language;

        return this.fetchPostRequest(path, data);
    }

    static requestCredentialsVerification(data) {
        let path = '/api/organization/consent-requests';

        return this.fetchPostRequestWithToken(path, data);
    }

    static getRequestsByStatus(status, page) {
        let path = '/api/user/consent-requests?statuses=' + (_.isArray(status) ? status.join(',') : status) + '&size=10';
        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        return this.fetchGetRequestWithToken(path)
    }

    static getConsentById(id) {
        let path = '/api/user/consent-requests/' + id;

        return this.fetchGetRequestWithToken(path);
    }

    static updateConsent(id, data) {
        let path = '/api/user/consent-requests/' + id + '/response';

        return this.fetchPutRequestWithToken(path, data);
    }

    static getOrganizationConsents(departmentId, filterParams) {
        let path = '/api/organization/consent-requests?departmentId=' + departmentId + '&size=10';
        if (!_.isNil(filterParams.updatedBefore)) {
            path += ('&updatedBefore=' + filterParams.updatedBefore);
        }
        if (!_.isNil(filterParams.status)) {
            path += ('&statuses=' + filterParams.status);
        }
        if (!_.isNil(filterParams.job)) {
            path += ('&jobTitleFilter=' + encodeURIComponent(filterParams.job));
        }

        return this.fetchGetRequestWithToken(path);
    }

    static getConsentRequestDetails(id) {
        let path = '/api/organization/consent-requests/' + id;

        return this.fetchGetRequestWithToken(path);
    }

    static abandonConsentRequest(id) {
        let path = '/api/organization/consent-requests/' + id;

        return this.fetchDeleteRequestWithToken(path);
    }

    static getUserSettings() {
        let path = '/api/user/settings';

        return this.fetchGetRequestWithToken(path);
    }

    static updateUserSettings(data) {
        let path = '/api/user/settings';

        return this.fetchPutRequestWithToken(path, data)
    }

    static getSecurityState() {
        let path = '/api/user/2fa/state';

        return this.fetchGetRequestWithToken(path);
    }

    static generate2FASecret() {
        let path = '/api/user/2fa/secret';

        return this.fetchPostRequestWithToken(path);
    }

    static enable2FA(checkCode) {
        let path = '/api/user/2fa/enable';
        if (!_.isNil(checkCode)) {
            path += ('?checkCode=' + checkCode);
        }

        return this.fetchPostRequestWithToken(path);
    }

    static disable2FA() {
        let path = '/api/user/2fa/disable';

        return this.fetchPostRequestWithToken(path);
    }

    static getPriorConsents(date) {
        let path = '/api/user/prior-consents';

        if (!_.isNil(date)) {
            path += '?enabledTillAfter=' + date;
        }

        return this.fetchGetRequestWithToken(path);
    }

    static createPriorConsent(data) {
        let path = '/api/user/prior-consents';

        return this.fetchPostRequestWithToken(path, data);
    }

    static getPriorConsentById(id) {
        let path = '/api/user/prior-consents/' + id;

        return this.fetchGetRequestWithToken(path);
    }

    static updatePriorConsent(id, data) {
        let path = '/api/user/prior-consents/' + id;

        return this.fetchPutRequestWithToken(path, data);
    }

    static removePriorConsent(id) {
        let path = '/api/user/prior-consents/' + id;

        return this.fetchDeleteRequestWithToken(path);
    }

    static getApplicantSelfStudyBooks() {
        let path = '/api/user/self-studies/books';

        return this.fetchGetRequestWithToken(path);
    }

    static addApplicantSelfStudyBooks(data) {
        let path = '/api/user/self-studies/books';

        return this.fetchPostRequestWithToken(path, data);
    }

    static getApplicantSelfStudyBook(id) {
        let path = '/api/user/self-studies/books/' + id;

        return this.fetchGetRequestWithToken(path);
    }

    static updateSelfStudyBook(id, data) {
        let path = '/api/user/self-studies/books/' + id;

        return this.fetchPutRequestWithToken(path, data);
    }

    static removeSelfStudyBook(id) {
        let path = '/api/user/self-studies/books/' + id;

        return this.fetchDeleteRequestWithToken(path);
    }

    static requestBulkCredentialsVerification(data) {
        let path = '/api/organization/consent-requests/bulk';

        return this.fetchPostRequestWithToken(path, data);
    }

    static getBulkRequestsJobs(departmentId) {
        let path = '/api/organization/consent-requests/bulk?departmentId=' + departmentId;

        return this.fetchGetRequestWithToken(path);
    }

    static removeBulkRequestJob(id) {
        let path = '/api/organization/consent-requests/bulk/' + id;

        return this.fetchDeleteRequestWithToken(path);
    }

    static resumeBulkRequestJob(id) {
        let path = '/api/organization/consent-requests/bulk/' + id + '/resume';

        return this.fetchPutRequestWithToken(path);
    }

    static getGlobalCertificates() {
        let path = '/api/system/ca/certificates';

        return this.fetchGetRequestWithToken(path);
    }

    static addGlobalCertificate(data) {
        let path = '/api/system/ca/certificates';

        return this.fetchPostRequestWithTokenWithTextBody(path, data);
    }

    static removeGlobalCertificate(certId) {
        let path = '/api/system/ca/certificates/' + certId;

        return this.fetchDeleteRequestWithToken(path);
    }

    static getOrgCertificates(orgId) {

        let path = '/api/system/organizations/' + orgId + '/certificates';

        return this.fetchGetRequestWithToken(path);
    }

    static addOrgCertificate(orgId, data) {
        let path = '/api/system/organizations/' + orgId + '/certificates';

        return this.fetchPostRequestWithTokenWithTextBody(path, data);
    }

    static removeOrgCertificate(orgId, certId) {
        let path = '/api/system/organizations/' + orgId + '/certificates/' + certId;

        return this.fetchDeleteRequestWithToken(path);
    }

    static verifyJWK(data) {
        let path = '/api/organization/verify-key';

        return this.fetchPostRequestWithToken(path, data);
    }

    static getAccreditationRequests() {
        let path = '/api/user/aar';

        return this.fetchGetRequestWithToken(path);
    }

    static createAccreditationRequest(data) {
        let path = '/api/user/aar';

        return this.fetchPostRequestWithToken(path, data);
    }

    static getAccreditationRequestById(id) {
        let path = '/api/user/aar/' + id;

        return this.fetchGetRequestWithToken(path);
    }

    static updateAccreditationRequest(id, data, fullUpdateRequired) {
        let path = '/api/user/aar/' + id + '?fullUpdateRequired=' + fullUpdateRequired;

        return this.fetchPutRequestWithToken(path, data);
    }

    static removeAccreditationRequest(id) {
        let path = '/api/user/aar/' + id;

        return this.fetchDeleteRequestWithToken(path);
    }

    static getOrgsForRequest(country, orgName) {
        let path = '/api/user/aar/organization';

        if (!_.isNil(country)) {
            path += '?country=' + country;
        }
        if (!_.isNil(orgName)) {
            path += (_.isNil(country) ? '?' : '&') + 'orgNameFilter=' + orgName;
        }

        return this.fetchGetRequestWithToken(path);
    }

    static getAGsForRequest(orgId) {
        let path = '/api/public/organization/' + orgId + '/accreditation-groups';

        return this.fetchGetRequestWithToken(path);
    }

    static getOrgByDomain(domain) {
        let path = '/api/public/organization/' + domain;

        return this.fetchGetRequestWithToken(path);
    }

    static getAccreditationRequestsByDomains(validated, domain, page, size) {
        //TODO: do not pass empty string
        let pageSize = 10;
        if (!_.isNil(size)) {
            pageSize = size;
        }
        let path = '/api/system/aar/domains?domainFilter=' + (!_.isNil(domain) ? domain : '') + '&size=' + pageSize;
        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }
        if (!_.isNil(validated)) {
            path += '&domainVerifiedFilter=' + validated;
        }

        return this.fetchGetRequestWithToken(path);
    }

    static updateAccreditationRequestByDomain(domain, data) {
        let path = '/api/system/aar/domains/' + domain;

        return this.fetchPutRequestWithToken(path, data);
    }

    static removeAccreditationRequestByDomain(domain) {
        let path = '/api/system/aar/domains/' + domain;

        return this.fetchDeleteRequestWithToken(path);
    }

    static getAccreditationRequestsByAGs(AG, page, size) {
        //TODO: do not pass empty string
        let pageSize = 10;
        if (!_.isNil(size)) {
            pageSize = size;
        }
        let path = '/api/organization/aar/accreditation-groups?agNameFilter=' + (!_.isNil(AG) ? AG : '') + '&size=' + pageSize;
        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        return this.fetchGetRequestWithToken(path);
    }

    static updateAccreditationRequestByAG(AGId, AGs) {
        let path = '/api/organization/aar/accreditation-groups/' + AGId;

        return this.fetchPutRequestWithToken(path, AGs);
    }

    static removeAccreditationRequestByAG(AGs) {
        let path = '/api/organization/aar/accreditation-groups/reject';

        return this.fetchPostRequestWithToken(path, AGs);
    }

    static getPendingAccreditationRequests(group, countryFilter, domainFilter, page, size) {
        let path = '/api/organization/aar?agIdFilter=' + group;
        let pageSize = 10;
        if (!_.isNil(size)) {
            pageSize = size;
        }
        path += '&size=' + pageSize;

        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        if (!_.isNil(countryFilter)) {
            path += ('&countryCodeFilter=' + countryFilter);
        }

        if (!_.isNil(domainFilter)) {
            path += ('&domainFilter=' + domainFilter);
        }

        return this.fetchGetRequestWithToken(path);
    }

    static getStaticsticsForPendingAccreditationRequests(group, countryCode, groupBy) {
        let path = '/api/organization/aar/statistics?agIdFilter=' + group;

        if (!_.isNil(countryCode)) {
            path += '&countryCodeFilter=' + countryCode;
        }

        if (!_.isNil(groupBy)) {
            path += '&groupBy=' + groupBy;
        }

        return this.fetchGetRequestWithToken(path);
    }

    static confirmAccreditationRequest(id, data) {
        let path = '/api/organization/accreditations?applicantAccreditationRequestId=' + id;

        return this.fetchPostRequestWithToken(path, data);
    }

    static rejectAccreditationRequest(id) {
        let path = '/api/organization/aar/' + id;

        return this.fetchDeleteRequestWithToken(path);
    }

    static getAccreditationRequestForProcessing(id) {
        let path = '/api/organization/aar/' + id;

        return this.fetchGetRequestWithToken(path);
    }

    static getLastRequestorsOfAccreditationRequestByDomain(domain) {
        let path = '/api/system/aar/domains/' + domain + '/users';

        return this.fetchGetRequestWithToken(path);
    }

    static getPricingPresetByAnchor(countryCode, organizationType) {
        let path = '/api/organization/pricing-preset?countryCode=' + countryCode + '&organizationType=' + organizationType;

        return this.fetchGetRequest(path);
    }

    static getAssistants() {
        let path = '/api/system/admins';

        return this.fetchGetRequestWithToken(path);
    }

    static addAssistant(data) {
        let path = '/api/system/admins';

        return this.fetchPostRequestWithToken(path, data);
    }

    static removeAssistant(id) {
        let path = '/api/system/admins/' + id;

        return this.fetchDeleteRequestWithToken(path);
    }

    static editAssistant(id, data) {
        let path = '/api/system/admins/' + id + '/subroles';

        return this.fetchPutRequestWithToken(path, data);
    }

    static getBusinessAmbassadors() {
        let path = '/api/system/business-ambassadors';

        return this.fetchGetRequestWithToken(path);
    }

    static addBusinessAmbassador(data) {
        let path = '/api/system/business-ambassadors';

        return this.fetchPostRequestWithToken(path, data);
    }

    static removeBusinessAmbassador(id) {
        let path = '/api/system/business-ambassadors/' + id;
        
        return this.fetchDeleteRequestWithToken(path);
    }

    static getBusinessAmbassador(id) {
        let path = '/api/system/business-ambassadors/' + id;
        
        return this.fetchGetRequestWithToken(path);
    }

    static updateBusinessAmbassador(id, data) {
        let path = '/api/system/business-ambassadors/' + id;
        
        return this.fetchPutRequestWithToken(path, data);
    }

    static getCommissions(page, filters) {
        let path = '/api/system/business-ambassadors/contracts?size=10';

        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        if (!_.isNil(filters)) {
            path += filters.baId ? ('&baIdFilter=' + filters.baId) : "";
            path += filters.countries ? ('&countryCodeFilter=' + (_.isArray(filters.countries) ? filters.countries.join(',') : filters.countries)) : "";
        }

        return this.fetchGetRequestWithToken(path);
    }

    static addCommission(baId, data) {
        let path = '/api/system/business-ambassadors/' + baId + '/contracts/';

        return this.fetchPostRequestWithToken(path, data);
    }

    static removeCommission(baId, commissionId) {
        let path = '/api/system/business-ambassadors/' + baId + '/contracts/' + commissionId;
        
        return this.fetchDeleteRequestWithToken(path);
    }

    static updateCommission(baId, commissionId, data) {
        let path = '/api/system/business-ambassadors/' + baId + '/contracts/' + commissionId;
        
        return this.fetchPutRequestWithToken(path, data);
    }

    static getCommissionData(baId, commissionId) {
        let path = '/api/system/business-ambassadors/' + baId + '/contracts/' + commissionId;
        
        return this.fetchGetRequestWithToken(path);
    }
    
    static getDuePaymentsForBAs(countries, name) {
        let path = '/api/system/business-ambassadors/transactions-statistics?size=10';

        if (!_.isNil(countries)) {
            path += ('&countryCodesFilter=' + countries.join(','));
        }
        if (!_.isEmpty(name)) {
            path += '&nameFilter=' + name;
        }

        path += '&transactionTypeFilter=PAYED_CONSENT_REQUEST_REMUNERATION,CONSENT_REQUEST_REMUNERATION_PAYMENT';

        return this.fetchGetRequestWithToken(path);
    }

    static getDuePaymentsForUniversities(page, countries, name) {
        let path = '/api/system/organizations/transactions-statistics?size=10';

        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        if (!_.isNil(countries)) {
            path += ('&countryCodesFilter=' + countries.join(','));
        }

        if (!_.isEmpty(name)) {
            path += '&nameFilter=' + name;
        }

        path += '&transactionTypeFilter=PAYED_CONSENT_REQUEST_REMUNERATION,CONSENT_REQUEST_REMUNERATION_PAYMENT';
        path += '&hasIVsFilter=true';

        return this.fetchGetRequestWithToken(path);
    }

    static getDuePaymentsForSystem() {
        let path = '/api/system/balance/transactions-statistics';

        return this.fetchGetRequestWithToken(path);
    }

    static payDuePaymentForSystem(data) {
        let path = '/api/system/balance/consent-request-remuneration';

        return this.fetchPostRequestWithToken(path, data);
    }

    static payDuePaymentsForBA(id, data) {
        let path = '/api/system/business-ambassadors/' + id + '/consent-request-remuneration';

        return this.fetchPostRequestWithToken(path, data);
    }

    static getPaymentsHistoryForBAs(page, filters) {
        let path = '/api/system/business-ambassadors/transactions-history?size=10';

        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        if (!_.isNil(filters)) {
            path += filters.dateFrom ? ('&dateFromFilter=' + filters.dateFrom) : "";
            path += filters.dateTo ? ('&dateToFilter=' + filters.dateTo) : "";
            path += filters.name ? ('&nameFilter=' + filters.name) : "";
            path += filters.countries ? ('&countryCodesFilter=' + filters.countries.join(',')) : "";
        }

        path += '&transactionTypeFilter=PAYED_CONSENT_REQUEST_REMUNERATION';

        return this.fetchGetRequestWithToken(path);
    }

    static getPaymentsHistoryForUniversities(page, filters) {
        let path = '/api/system/organizations/transactions-history?size=10';

        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        if (!_.isNil(filters)) {
            path += filters.dateFrom ? ('&dateFromFilter=' + filters.dateFrom) : "";
            path += filters.dateTo ? ('&dateToFilter=' + filters.dateTo) : "";
            path += filters.name ? ('&nameFilter=' + filters.name) : "";
            path += filters.countries ? ('&countryCodesFilter=' + filters.countries.join(',')) : "";
        }

        path += '&transactionTypeFilter=PAYED_CONSENT_REQUEST_REMUNERATION';

        return this.fetchGetRequestWithToken(path);
    }

    static getCompaniesCredits(page, sorting, name, countries) {
        let path = '/api/system/organizations/transactions-statistics?size=10';

        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        if (!_.isNil(sorting)) {
            path += ('&orderBy=' + sorting);
        }

        if (!_.isNil(name)) {
            path += '&nameFilter=' + name;
        }

        if (!_.isNil(countries)) {
            path += '&countryCodesFilter=' + countries.join(',');
        }

        path += '&transactionTypeFilter=ANNUAL_FEE_PAYMENT,CONSENT_REQUEST_FEE_PAYMENT';

        return this.fetchGetRequestWithToken(path);
    }

    static getCompanyCreditsHistory(page, id) {
        let path = '/api/system/organizations/' + id + '/transactions-history?size=10';

        if (!_.isNil(page)) {
            path += ('&page=' + page);
        }

        return this.fetchGetRequestWithToken(path);
    }

    static getOperationAvailability() {
        let path = '/api/organization/operation-availability';

        return this.fetchGetRequestWithToken(path);
    }

    static payDuePaymentsForUniversity(id, data) {
        let path = '/api/system/organizations/' + id + '/consent-request-remuneration';

        return this.fetchPostRequestWithToken(path, data);
    }

    static removeOrg(id) {
        let path = '/api/system/organizations/' + id;

        return this.fetchDeleteRequestWithToken(path);
    }

    static markOrgAsBava(id) {
        let path = '/api/system/organizations/' + id + '/bava';

        return this.fetchPutRequestWithToken(path);
    }

    static removeBavaFlag() {
        let path = '/api/system/organizations/bava';

        return this.fetchDeleteRequestWithToken(path);
    }

    static getValidatedDomains(countryCode, name, domain, page) {
        let path = '/api/system/aar/domains?size=10&domainVerifiedFilter=true';

        if (domain) {
            path += '&domainFilter=' + domain;
        }

        if (countryCode) {
            path += '&countryCodeFilter=' + countryCode;
        }

        if (name) {
            path += '&nameFilter=' + name;
        }

        if (page) {
            path += '&page=' + page;
        }

        return this.fetchGetRequestWithToken(path);
    }

    static addValidatedDomain(data, bavaManaged) {
        let path = '/api/system/organizations/managed-organizations/?bavaManaged=' + bavaManaged;

        return this.fetchPostRequestWithToken(path, data);
    }

    static editValidatedDomain(domain, data, bavaManaged) {
        let path = '/api/system/aar/domains/' + domain + '?bavaManaged=' + bavaManaged;

        return this.fetchPutRequestWithToken(path, data);
    }

    static removeValidatedDomain(domain) {
        let path = '/api/system/aar/domains/' + domain;

        return this.fetchDeleteRequestWithToken(path);
    }

    static validateDomain(domain, data, bavaManaged) {
        let path = '/api/system/aar/domains/' + domain + '?bavaManaged=' + bavaManaged;

        return this.fetchPostRequestWithToken(path, data);
    }

    static getManagedOrgs(countryCode) {
        let path = '/api/organization/managed-organizations';

        if (countryCode) {
            path += '?countryCodeFilter=' + countryCode;
        }

        return this.fetchGetRequestWithToken(path);
    }
}



// WEBPACK FOOTER //
// ./src/api/api.js